export const ACTION_REJECT = 'reject';
export const ACTION_REVISE = 'revise';
